import domain from './domain';

// Reset task categories
export const resetTaskCategories = domain.createEvent('resetTaskCategories');
